/** Reason recorded when a Lost submission is re-opened from the console. */
export const REOPEN_FROM_LOST_REASON =
  'Submission was re-opened from lost status.';
